import { motion } from "framer-motion";

/**
 * Masked line-by-line reveal — the signature on-load moment.
 * `lines` is an array of strings OR an array of React nodes.
 * Each line is wrapped in an overflow-hidden box and translated up from below.
 */
export default function MaskedLines({ lines, className = "", lineClassName = "", delay = 0, stagger = 0.1 }) {
  return (
    <h1 className={className} aria-label={typeof lines[0] === "string" ? lines.join(" ") : undefined}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden" style={{ paddingBottom: "0.06em" }}>
          <motion.span
            className={`block will-change-transform ${lineClassName}`}
            initial={{ y: "115%", opacity: 0 }}
            animate={{ y: "0%", opacity: 1 }}
            transition={{
              duration: 1.05,
              delay: delay + i * stagger,
              ease: [0.19, 1, 0.22, 1], // expo out
            }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </h1>
  );
}
